import React, { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabaseClient';
import { getCurrentUserOrganizationId } from '@/lib/data';

export function MobileEventsTest() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [orgId, setOrgId] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        
        // Get organization ID
        const organizationId = await getCurrentUserOrganizationId();
        setOrgId(organizationId);
        console.log('Organization ID:', organizationId);
        
        if (!organizationId) {
          throw new Error('No organization ID found');
        }

        // Load events
        const { data, error } = await supabase
          .from('events')
          .select('*')
          .eq('organization_id', organizationId)
          .order('start_time', { ascending: true });

        if (error) {
          console.error('Supabase error:', error);
          throw error;
        }

        console.log('Events loaded:', data);
        setEvents(data || []);
      } catch (err) {
        console.error('Error loading data:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div>
      <h1>Mobile Events Test</h1>
      <p>Organization ID: {orgId}</p>
      <p>Events count: {events.length}</p>
      <pre>{JSON.stringify(events, null, 2)}</pre>
    </div>
  );
}